import { render } from "./BuyukSehirCDP.vue?vue&type=template&id=06008dce"
import script from "./BuyukSehirCDP.vue?vue&type=script&lang=js"
export * from "./BuyukSehirCDP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__